import { ApolloProvider } from '@apollo/client';
import { apolloClient } from 'graphql/client';
import { ResetCSS } from 'common/assets/css/style';
import 'index.css';
import { darkTheme } from 'common/theme/dark/darkTheme';
import { lightTheme } from 'common/theme/light/lightTheme';
import Seo from 'components/seo';
import GlobalStyle, { ContentWrapper } from 'containers/app.style';
import React, { useState } from 'react';
import { ThemeProvider } from 'styled-components';
import Footer from 'containers/Footer';
import HeaderSection from 'containers/HeaderSection';
import 'react-pro-sidebar/dist/css/styles.css';
import SidebarSection from 'containers/SidebarSection';
import useDarkMode from 'use-dark-mode';

type Props = {
  className?: string;
  noGutter?: boolean;
  marginBottom?: string;
}


const App: React.FC<Props> = (props) => {
  const darkMode = useDarkMode();
  const theme = darkMode.value ? darkTheme : lightTheme;

  const [showSidebar, setShowSidebar] = useState(false);
  const sidebarClassName = showSidebar ? 'show' : '';
  
  return (
    <ThemeProvider theme={theme}>
      <ApolloProvider client={apolloClient}>
        <Seo title="ICHI" />
        <ResetCSS />
        <GlobalStyle />
        <div style={{position: 'relative'}}>
          <SidebarSection sidebarClassName={sidebarClassName} showSidebar={setShowSidebar} themeToggle={darkMode.toggle} />
          <ContentWrapper className={`${props.className}`}>
            <HeaderSection showSidebar={setShowSidebar}  themeToggle={darkMode.toggle} themeName={theme.name} /> 
              {props.children}
            <Footer />
          </ContentWrapper>
        </div>
      </ApolloProvider>
    </ThemeProvider>
  );
};
export default App;
